module.exports = __webpack_public_path__ + "media/images/flags/ug-667e1bd45c5bd6fe32206b64021cbe38.svg";